export default __webpack_public_path__ + "795d799d03e9bb36fd0887c57b13ac70.png";